import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStorageItem } from "../utilities/storageManager";

export const loadUserFromStorage = createAsyncThunk(
  // async thunk function (= returns function [not object] that performs async operation and then dispatches action ie updates store)
  // fetches user data from storage and returns it
  // async to ensure store loads before rendering app
  "user/loadUserFromStorage",
  () => {
    return getStorageItem("user");
  }
);

const initialState = {
  isAuthenticated: false,
  stayLoggedIn: false,
  isAdmin: false,
  isOnline: false,
  unreadMessages: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState:  JSON.parse(JSON.stringify(initialState)),
  reducers: {
    setUser: (state, action) => {
      const {
        id,
        firstName,
        lastName,
        email,
        isAuthenticated,
        isAdmin,
        stayLoggedIn,
        isOnline,
      } = action.payload;
      state.id = id;
      state.firstName = firstName;
      state.lastName = lastName;
      state.email = email;
      state.isAuthenticated = isAuthenticated;
      state.isAdmin = isAdmin;
      state.isOnline = isOnline;
      state.stayLoggedIn = stayLoggedIn;
    },
    removeUser: (state) => {
      return  JSON.parse(JSON.stringify(initialState));
    },
    setAdminOnlineStatus: (state, action) => {
      const { isOnline } = action.payload;
      state.isOnline = isOnline;
    },
    setRoomHasUnreadMsg: (state, action) => {
      const { hasNewMessage, sessionId } = action.payload;
      if(!state.isAdmin){
        if(hasNewMessage){
          state.unreadMessages = {[sessionId]: true}
        } else {
          state.unreadMessages = {};
        }
      } else {
        // admin 
        if (hasNewMessage) {
          state.unreadMessages = {
            ...state.unreadMessages,
            [sessionId]: hasNewMessage,
        };
      } else {
          let updatedUnreadMessages = { ...state.unreadMessages };
          delete updatedUnreadMessages[sessionId];
          state.unreadMessages = updatedUnreadMessages;
      }
      }
    },
    clearAllUnreadMsgs: (state, action) => {
      state.unreadMessages = {}; 
    }
  },
  //   define action for outcome of async thunk
  extraReducers: (builder) => {
    builder
      .addCase(loadUserFromStorage.fulfilled, (state, action) => {
        if (action.payload) {
          const {
            id,
            firstName,
            lastName,
            email,
            isAuthenticated,
            isAdmin,
            stayLoggedIn,
            isOnline,
            unreadMessages,
          } = action.payload;
          state.isAuthenticated = isAuthenticated || false;
          state.isAdmin = isAdmin || false;
          state.isOnline = isOnline || false;
          state.stayLoggedIn = stayLoggedIn || false;
          if (id) {
            //will be undefined if no data in storage
            state.id = id;
            state.firstName = firstName;
            state.lastName = lastName;
            state.email = email;
          }
          state.unreadMessages = {};
          if (!isAdmin || (isAdmin && isOnline)) {
            state.unreadMessages = unreadMessages || {};
          }
        }
      })
      .addCase(loadUserFromStorage.rejected, (state, action) => {
        return  JSON.parse(JSON.stringify(initialState));
      });
  },
});

//export actions
export const {
  setUser,
  removeUser,
  setAdminOnlineStatus,
  setRoomHasUnreadMsg,
  clearAllUnreadMsgs,
} = userSlice.actions;
//
//export reducer
export default userSlice.reducer;
